import { OptionDescription } from './option.type';
import { ENumberOf } from '../enums/number-of.enum';

export type NumberOfRecord = Record<ENumberOf, OptionDescription<ENumberOf>>;
